import React from 'react';
import {Plus, Minus, RotateCcw} from 'lucide-react';

const ZoomControls = ({zoomLevel, onZoomIn, onZoomOut, onResetZoom}) => (
  <div className="flex items-center gap-2 bg-white p-2 rounded-lg shadow-sm border border-[#9FBDED]">
    <button
      className="p-1 rounded-full bg-[#EEF3FC] hover:bg-[#DAE4F4] transition-colors"
      onClick={onZoomOut}
      title="Zoom out"
    >
      <Minus className="w-4 h-4 text-[#033971]" />
    </button>

    <div className="flex items-center">
      <span className="text-sm font-medium text-[#033971] min-w-[50px] text-center">
        {zoomLevel}x
      </span>
    </div>

    <button
      className="p-1 rounded-full bg-[#EEF3FC] hover:bg-[#DAE4F4] transition-colors"
      onClick={onZoomIn}
      title="Zoom in"
    >
      <Plus className="w-4 h-4 text-[#033971]" />
    </button>

    <button
      className="p-1 rounded-full bg-[#EEF3FC] hover:bg-[#DAE4F4] transition-colors ml-1"
      onClick={onResetZoom}
      title="Reset zoom"
    >
      <RotateCcw className="w-4 h-4 text-[#033971]" />
    </button>
  </div>
);

export default ZoomControls;
